import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../../data/mock';

export const ServicesOverview = () => {
  return (
    <section className="py-16 lg:py-24 bg-white relative overflow-hidden" data-testid="services-overview-section">
      <div className="container mx-auto px-4 relative">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-500 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Onze diensten
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-neutral-900 mb-6">
            Onze diensten voor een <span className="gradient-text">zorgeloze gym setup</span>
          </h2>
          <p className="text-xl text-neutral-600 leading-relaxed">
            Van transport tot installatie: wij helpen u met de volledige uitvoering van uw gymproject.
          </p>
        </div>

        {/* Service cards - GymNest style: large image cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative rounded-3xl overflow-hidden bg-neutral-50 border border-neutral-100 hover:border-yellow-300 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 flex flex-col"
              data-testid={`service-card-${service.id}`}
            >
              {/* Text top */}
              <div className="p-8 pb-6">
                <h3 className="text-2xl font-black text-neutral-900 mb-2 group-hover:text-yellow-500 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-neutral-600 leading-relaxed mb-5">{service.shortDescription}</p>
                <Link
                  to="/diensten"
                  className="inline-flex items-center gap-2 bg-neutral-900 group-hover:bg-yellow-400 text-white group-hover:text-black px-6 py-3 rounded-full font-bold text-sm transition-all duration-300"
                >
                  Bekijk meer
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>

              {/* Image bottom */}
              <div className="mt-auto aspect-[4/3] overflow-hidden">
                <img
                  src={service.image}
                  alt={`${service.title} - NEXON Installatie & Service`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
